import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import EmblaCarousel from 'embla-carousel';
import { EmblaCarouselType } from 'embla-carousel/components';

@Component({
  standalone: false,
  selector: 'ssc-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselComponent implements AfterViewInit {
  @Input() public titleKey: string;
  @Input() public startIndex?: number;
  public slideSelectionStates: boolean[];
  public carousel: EmblaCarouselType;

  @ViewChild('carouselRef') private carouselRef: ElementRef;

  constructor(private changeDetectionRef: ChangeDetectorRef) {}

  public ngAfterViewInit(): void {
    // wait until elements are rendered to make sure the carousel library can measure their size
    setTimeout(() => {
      const container = this.carouselRef.nativeElement.children[0];
      const slides = Array.from<HTMLElement>(container.querySelectorAll('.carousel-slide'));
      this.carousel = EmblaCarousel(this.carouselRef.nativeElement, {
        container,
        slides,
        startIndex: this.startIndex,
        loop: false,
        align: 'start',
        skipSnaps: false,
      });

      this.slideSelectionStates = this.getSlideSelectionStates();
      this.carousel.on('select', () => this.updateSelectedButton());
      this.changeDetectionRef.markForCheck();
    }, 0);
  }

  private getSlideSelectionStates(): boolean[] {
    return this.carousel.slideNodes().map((_, index) => index === 0);
  }

  public onDotClick(clickedIndex: number): void {
    this.carousel.scrollTo(clickedIndex);
    this.updateSelectedButton();
  }

  private updateSelectedButton(): void {
    const previous = this.carousel.previousScrollSnap();
    const current = this.carousel.selectedScrollSnap();
    this.slideSelectionStates[previous] = false;
    this.slideSelectionStates[current] = true;
    this.changeDetectionRef.markForCheck();
  }
}
